// eslint-disable-next-line import/prefer-default-export
export const WorkplanStatus = Object.freeze({
    NotStarted: 0,
    Played: 1,
});
